import { useEffect, useState } from "react";
import api from "@/lib/api";

// Returns a Set of product_ids the signed-in user already owns (paid orders).
export function useOwned() {
  const [ids, setIds] = useState(() => new Set());
  useEffect(() => {
    let alive = true;
    api.get("/me/owned")
      .then((r) => { if (alive) setIds(new Set(r.data.product_ids || [])); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return ids;
}
